<template>
    <div class='product-types'>
        <product-type-filters @update-filters="onUpdateFilters"  ref="filtersComponent"></product-type-filters>
        <div class="product-types-list">
            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} Types de produit</div>
                <el-pagination
                    @current-change="page => paginate(page, 'top')"
                    :current-page.sync="params.page"
                    :page-size="params.limit"
                    :pager-count="11"
                    layout="sizes, prev, pager, next"
                    :page-sizes="page_sizes"
                    @size-change="handleSizeChange"
                    :total="total_item"
                ></el-pagination>
            </div>

            <el-table style="width: 100%" ref="multipleTable" :data="types_product" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column prop="shop_id" label="ID Speedway" sortable="custom" width="150"></el-table-column>
                <el-table-column prop="value" label="Nom" sortable="custom"></el-table-column>

                <el-table-column label="Actions" fixed="right" width='150'>
                    <template slot-scope="scope">
                        <button :title="scope.row.id" class="btn btn-icon btn-link" @click="openModalEdit(scope.row)">
                            <i class="fe fe-edit"></i>
                        </button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>

            <el-dialog
                :title="'Modification ' + (modal.product_type.value || '')"
                :visible.sync="modal.display"
                :fullscreen="false"
                v-loading="modal.loader"
                append-to-body
            >
                <product-type-edit
                    ref="sentencesEdit"
                    :product-type-id="modal.product_type.id"
                    :close-on-press-escape="false"
                    :close-on-click-modal="false"
                    @close="closeModalEdit"
                ></product-type-edit>
            </el-dialog>
        </div>

    </div>
</template>

<script>
import Feature from '../../models/Feature';
import ProductTypeEdit from './Edit';

export default {
    components: {
        ProductTypeEdit
    },
    data() {
        return {
            loading: false,
            types_product: [],
            total_item: 0,
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'value',
                order: 'ASC',
                limit: 10
            },
            modal: {
                display: false,
                product_type: {}
            },
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {

    },
    methods: {
        fetch() {
            this.loading = true;
            axios.get('/product_types', {params: this.params}).then(response => {
                this.types_product = response.data.data;
                this.total_item = response.data.total;
                this.loading = false;
            });
        },
        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },
        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
            this.loader = false;
        },
        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order === 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },
        openModalEdit(product_type) {
            this.modal.display = true;
            this.modal.product_type = product_type;
        },
        closeModalEdit() {
            this.modal.display = false;
            this.modal.product_type = {};
        },
        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },
        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },
    }
};
</script>

<style scoped>

</style>
